<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item to="/template/list">群发任务</el-breadcrumb-item>
        <el-breadcrumb-item>群发详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">群发详情</h2>
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top: 20px;"
    >
      <div class="modular">
        <div class="title">基本信息</div>
        <div class="item-wrap">
          <div class="item">
            <div class="label">模板ID</div>
            <div class="value">{{detail.template_code}}</div>
          </div>
          <div class="item">
            <div class="label">短信全文</div>
            <div class="value">{{detail.template_content}}</div>
          </div>
          <div class="item">
            <div class="label">号码数量</div>
            <div class="value">{{detail.count_msg_total}}</div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="modular">
        <div class="title">发送结果</div>
        <div class="count-wrap">
          <div class="count-item">
            <div class="count-label">发送号码总量</div>
            <div class="count-value">{{ detail.count_msg_total }}</div>
          </div>
          <div class="count-item">
            <div class="count-label">发送成功</div>
            <div
              class="count-value"
              style="color: #00A870;"
            >{{ detail.count_msg_suc }}</div>
          </div>
          <div class="count-item">
            <div class="count-label">发送失败</div>
            <div
              class="count-value"
              style="color: #F36D78;"
            >{{ detail.count_msg_fail }}</div>
          </div>
          <div class="count-item">
            <div class="count-label">发送中</div>
            <div class="count-value">{{ detail.count_msg_ready }}</div>

          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="modular">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            type="index"
            align="center"
            width="80"
          >
          </el-table-column>
          <!--   <el-table-column
            label="昵称/真实姓名"
            align="center"
            prop="name"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            label="手机号"
            align="center"
            prop="mobile"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                type="warning"
                v-if="scope.row.status==0"
              >待发送</el-tag>
              <el-tag
                size="mini"
                type="success"
                v-if="scope.row.status==1"
              >已发送</el-tag>
              <el-tag
                size="mini"
                type="danger"
                v-if="scope.row.status==2"
              >发送失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="错误代码"
            align="center"
            prop="error_code"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="错误原因"
            align="center"  
            prop="error_reason"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="发送时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.send_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            background
            layout="total, prev, pager, next, sizes, jumper"
            :current-page="Number(query.pageIndex)"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="Number(query.pageSize)"
            :total="Number(pageTotal)"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>


import { smsSendTasksinglelist } from "@/api/operation";
export default {
  components: {
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,

      results: [],
      detail: {},
    };
  },
  created() {
    this.detail = JSON.parse(this.$route.query.data)
    console.log(this.detail);
    this.fetchList()
  },
  methods: {
    fetchList() {
      const params = Object.assign({}, this.query, { send_task_id: this.$route.query.id })
      smsSendTasksinglelist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
  },
};
    </script>
    
    <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    .line {
      height: 1px;
      background: #eeeeee;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin: 24px 0px;
    }
    .modular {
      .title {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }
      .item-wrap {
        margin-top: 18px;

        .item {
          display: flex;
          align-items: flex-start;
          margin-top: 18px;
          .label {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            width: 100px;
          }
          .value {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      .count-wrap {
        background: #f5f8fe;
        border-radius: 0px 0px 0px 0px;
        padding: 28px;
        margin-top: 18px;
        display: flex;
        justify-content: space-between;
        .count-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .count-label {
            font-size: 18px;
            font-weight: 600;
            color: #333;
          }
          .count-value {
            font-size: 28px;
            color: #333;
            font-weight: 600;
            margin-top: 8px;
          }
        }
      }
    }
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
    